import InstallmentsTable from "./InstallmentsTable";
export default InstallmentsTable;
